import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable"
export default class extends Controller {
  static targets = ["item"]
  static values = {
    url: String,
    paramName: { type: String, default: "room_type_ids" },
    autoSubmit: { type: Boolean, default: true }
  }

  connect() {
    // Find the grid container within this sortable container
    const gridContainer = this.element.querySelector('.grid')
    
    if (gridContainer) {
      this.sortable = Sortable.create(gridContainer, {
        animation: 250,
        easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen', 
        dragClass: 'sortable-drag',
        draggable: '[data-sortable-target="item"]',
        filter: '.no-drag',
        preventOnFilter: false,
        swapThreshold: 0.6,
        
        onStart: (event) => {
          // Subtle drag effect
          event.item.style.transform = 'rotate(2deg) scale(1.05)'
          event.item.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'
          event.item.style.zIndex = '1000'
          event.item.style.opacity = '0.9'
          
          document.body.classList.add('dragging')
        },
        
        onMove: (event) => {
          // Subtle shift animation for other items
          const related = event.related
          if (related && !related.classList.contains('sortable-ghost')) {
            related.style.transform = 'translateY(-2px)'
            related.style.background = 'rgba(59, 130, 246, 0.05)'
            related.style.transition = 'all 0.2s ease'
            
            setTimeout(() => {
              related.style.transform = ''
              related.style.background = ''
            }, 300)
          }
          
          return true
        },
        
        onEnd: (event) => {
          // Clear drag styles
          event.item.style.transform = ''
          event.item.style.boxShadow = ''
          event.item.style.zIndex = ''
          event.item.style.opacity = ''
          
          document.body.classList.remove('dragging')
          
          // Update order if position changed
          if (event.oldIndex !== event.newIndex && this.autoSubmitValue) {
            this.updateOrder()
          }
        }
      })
    }
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async updateOrder() {
    const ids = this.itemTargets.map(item => item.dataset.id)

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          [this.paramNameValue]: ids
        })
      })
      
      if (response.ok) {
        // Show success toast
        this.showNotification('Room order updated', 'success')
      } else {
        const errorData = await response.json()
        this.showNotification(errorData.error || 'Failed to update room order', 'error')
      }
    } catch (error) {
      // Show error toast if something goes wrong
      this.showNotification('Failed to update room order', 'error')
    }
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }
  showNotification(message, type) {
    const notification = document.createElement('div')
    notification.className = `alert alert-${type} fixed top-20 right-10 z-50 max-w-md shadow-lg`
    notification.innerHTML = `<span>${message}</span>`

    document.body.appendChild(notification)

    setTimeout(() => notification.remove(), 3000)
  }
}